import $ from 'jquery';
import Masonry from './../libs/Masonry';

class CategoryTrigger {
    constructor() {
        if ($('.irantheme-wrapper-categories-trigger').length) {
            $('.irantheme-wrapper-categories-trigger').each(
                function (index, element) {
                    const postsContainer = $(element).find(
                        '.irantheme-categories-posts',
                    )[0];

                    // Initialize Masonry
                    let masonry = new Masonry(postsContainer, {
                        itemSelector: '.post-holder',
                        columnWidth: '.post-holder',
                    });

                    // Helper function to refresh Masonry
                    function refreshMasonry() {
                        if (masonry && typeof masonry.layout === 'function') {
                            masonry.layout();
                        } else if (
                            masonry &&
                            typeof masonry.reload === 'function'
                        ) {
                            masonry.reload();
                        } else if (
                            masonry &&
                            typeof masonry.init === 'function'
                        ) {
                            masonry.init();
                        } else if (
                            masonry &&
                            typeof masonry.reloadItems === 'function'
                        ) {
                            masonry.reloadItems();
                            if (typeof masonry.layout === 'function') {
                                masonry.layout();
                            }
                        } else {
                            console.warn(
                                'Layout method not found, recreating Masonry',
                            );
                            masonry = new Masonry(postsContainer, {
                                itemSelector: '.post-holder',
                                columnWidth: '.post-holder',
                            });
                        }
                    }

                    // Back to all posts
                    $(element)
                        .find('.irantheme-all-categories')
                        .on('click', function () {
                            $(element)
                                .find(
                                    '.irantheme-categories-trigger ul li span',
                                )
                                .removeClass('active');
                            $(this).addClass('active');

                            const $posts = $(element).find(
                                '.irantheme-categories-posts .post-holder[data-cate]',
                            );

                            // Fade all posts in and refresh once after all animations complete
                            let animationCount = $posts.length;
                            if (animationCount === 0) {
                                refreshMasonry();
                            } else {
                                $posts.fadeIn(250, function () {
                                    animationCount--;
                                    if (animationCount === 0) {
                                        refreshMasonry();
                                    }
                                });
                            }
                        });

                    // Categorize and alignment posts
                    $(element)
                        .find(
                            '.irantheme-categories-trigger ul li span:not(.irantheme-all-categories)',
                        )
                        .on('click', function () {
                            $(element)
                                .find(
                                    '.irantheme-categories-trigger ul li span',
                                )
                                .removeClass('active');
                            $(this).addClass('active');

                            const $allPosts = $(element).find(
                                '.irantheme-categories-posts .post-holder[data-cate]',
                            );

                            // Hide all posts immediately (no delay)
                            $allPosts.hide();

                            var baseData = $(this).data('cate');
                            var posts = $allPosts;
                            let $postsToShow = $();
                            let dataFiltered;

                            // First, collect all posts that should be shown
                            for (let i = 0; i < posts.length; i++) {
                                let dataPost = $(posts[i])
                                    .attr('data-cate')
                                    .split(',');
                                dataFiltered = dataPost.filter(function (el) {
                                    return el != '';
                                });

                                let uniqueData = [];
                                $.each(dataFiltered, function (i, el) {
                                    if ($.inArray(el, uniqueData) === -1)
                                        uniqueData.push(el);
                                });

                                for (let j = 0; j < uniqueData.length; j++) {
                                    if (uniqueData[j] == baseData) {
                                        $postsToShow = $postsToShow.add(
                                            $(posts[i]),
                                        );
                                        break;
                                    }
                                }
                            }

                            // Fade in matching posts and refresh immediately after animation
                            let animationCount = $postsToShow.length;
                            if (animationCount === 0) {
                                refreshMasonry();
                            } else {
                                $postsToShow.fadeIn(250, function () {
                                    animationCount--;
                                    if (animationCount === 0) {
                                        refreshMasonry();
                                    }
                                });
                            }
                        });
                },
            );
        }

        this.events();
    }

    events() {}
}

export default CategoryTrigger;
